<template>
    <div id="unEntryManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:8px" class="hewidth">
                <el-select v-model="searchForm.status" placeholder="请选择入库状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList"
                        :label="item.paraName"
                        :value="item.paraCode"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select clearable filterable v-model="searchForm.fetchPerson" @change="changeFetchPerson" :filter-method="PinyinMatch" placeholder="取机人">
                    <el-option v-for="item,index in engineersList"
                        :key="index"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.qrCode" placeholder="请输入二维码编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.orderSn" placeholder="请输关联订单号" ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-date-picker
                        style="width: 240px;margin-bottom:10px;"
                        v-model="valueTime1"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="创建开始"
                        end-placeholder="创建结束">
                    </el-date-picker>
            <el-form-item style="width: 30% margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
                <!-- <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button> -->
                 <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <!-- <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i> -->
            </el-form-item>
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                   <el-button size="medium" v-if="basicsAuth.create_code" type="success" @click="getCreateCode(0)" style="">条形码打印预览</el-button>
                   <el-button size="medium" v-if="basicsAuth.create_code" type="success" @click="getCreateCode(1)">打印条形码</el-button>

                </el-col>
            </el-form-item> -->
        </el-form>
        <el-col>
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        prop="orderSn"
                        align="center"
                        width="200"
                        label="订单编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="engineerName"
                        width="120"
                        label="取机人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        width="130"
                        label="手机号码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="150"
                        label="故障">
                        <template slot-scope="scope">
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassShortName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="qrCode"
                        width="100"
                        label="二维码">
                    </el-table-column>

                    <el-table-column
                    align="center"
                    width="160"
                    prop="createTime"
                    sortable
                    label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | date}} </span>
                    </template>
                </el-table-column>
                    <el-table-column
                        prop="modelName"
                        align="center"
                        width="150"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        prop="colorName"
                        align="center"
                        width="80"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="remark"
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="refundReason"
                        width="80"
                        label="操作" v-if="basicsAuth.ensure">
                        <template slot-scope="scope">
                            <span class="active-status" v-if="scope.row.status == '1'" @click="overOrder(scope.row)">结束订单</span>

                            <!-- <span class="active-status" v-if="scope.row.status == '1'" @click="confirmBtn(scope.row)">确认收到</span> -->
                            <span v-else>已收到</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50,100,200,500,1000,5000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match';
    import {needCLodop,getLodop} from '@/util/LodopFuncs'
    import { shopInventoryList,finishOrder,confirmEnsure,selectParameterInfoBusiness,createCode,engineerList } from "../../../api/api";
    import {getPermission} from '../../../api/authRequest'
    export default {
        name: 'unEntryManage',
        data () {
            return {
                pickingStatusList:[
                    {
                        paraName:'待确认',
                        paraCode:'1'
                    },
                    {
                        paraName:'已确认',
                        paraCode:'2'
                    }
                ],
                engineersList:[],
                copy:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    type:"1",
                    qrCode:'',  //二维码编号
                    status:'',  //入库状态
                    orderSn:'',  //关联订单号
                    fetchPerson:'',
                    phone:'',
                    attribute1:'',
                    attribute2:'',
                },
                modelForm:{
                    id:'',
                    orderId:'',
                    maintenance_status:"1"
                },
                returnData: [],
                codeList:[],
                valueTime1:[],
                basicsAuth:{
                    ensure:false,
                    create_code:false
                }
            }
        },
        created(){
            this.basicsAuth.ensure = getPermission('/api/shopInventory/ensure');
            this.basicsAuth.create_code = getPermission('/api/shopInventory/create_code');

            this.getShopInventoryList();
            this.getEngineerList();
        },
        methods: {
            //强制刷新
            changeFetchPerson(e){
                console.log(e);
                this.searchForm.fetchPerson = e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.fetchPerson = val;
                    this.engineersList = result;
                }else{
                    this.engineersList = this.copy;
                    this.searchForm.fetchPerson = "";
                }
            },
            //获取工程师
            getEngineerList(){
                let params = {
                    startRow:1,
                    pageSize:10000,
                }
                engineerList(params).then(res => {
                    if (res.data.status==100) {
                        this.engineersList = res.data.results.list;
                        this.copy = Object.assign(this.engineersList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            confirmBtn(row){
                this.modelForm.id = row.id;
                this.modelForm.orderId = row.orderId;
                let message = '是否确认收到该设备？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.submitConfirmModel()
                }).catch(action => {

                });
            },
            //结束订单
            overOrder(row){
                console.log(row)
                if(!row.id || !row.orderId){
                    return
                }
                finishOrder({id:row.id,orderId:row.orderId}).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getShopInventoryList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取取机码
            getCreateCode(type) {
                this.codeList = [];
                createCode({}).then(res => {
                    if (res.data.status == '100') {
                        let arr = [];
                        arr.push(res.data.results);
                        let obj = {
                            materialCode:"0000000000",
                            materialName:'取机带回',
                            list:arr
                        }
                        this.codeList.push(obj);
                        if(type == 0)this.PrintingPreviewRecord();
                        else this.PrintingBarCode();
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //确认收到
            submitConfirmModel(){
                confirmEnsure(this.modelForm).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getShopInventoryList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.type="1"
                this.getShopInventoryList();
            },
            //获取退款申请管理列表
            getShopInventoryList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                shopInventoryList(this.searchForm).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //条形码打印*预览
            PrintingRecord(data,type){  //type:0=》预览 1=》打印
                let LODOP = getLodop();
                LODOP.PRINT_INITA(1,-2,600,600,"");
                data.forEach((item,index)=>{
                    item.list.forEach((item1,index1) =>{
                        LODOP.ADD_PRINT_BARCODE(18, 132, 118, 23, "Code39", item1);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
                        LODOP.ADD_PRINT_BARCODE(18, 5, 118, 26, "Code39", item.materialCode);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
                        LODOP.ADD_PRINT_TEXT(50, 3, 120, 44, item.materialName);
                        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
                        LODOP.ADD_PRINT_BARCODE(58, 132, 118, 23, "Code39", item1);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
                        LODOP.ADD_PRINT_BARCODE(99, 132, 118, 23, "Code39", item1);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize",7);
                        LODOP.NEWPAGE();
                        // LODOP.ADD_PRINT_BARCODE(267, 215, 100, 21, "Code39", item1);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
                        // LODOP.ADD_PRINT_BARCODE(267, 89, 118, 26, "Code39", item.materialCode);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
                        // LODOP.ADD_PRINT_TEXT(303, 87, 117, 44, item.materialName);
                        // LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
                        // LODOP.ADD_PRINT_BARCODE(309, 215, 100, 21, "Code39", item1);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
                        // LODOP.ADD_PRINT_BARCODE(348, 215, 100, 21, "Code39", item1);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize",8);
                        // LODOP.NEWPAGE();
                    })
                })
                if(type == 0)LODOP.PREVIEW();
                else LODOP.PRINT();
            },
            //全部打印条形码
            PrintingBarCode(){
                this.PrintingRecord(this.codeList,1);
            },
            //全部条形码打印预览
            PrintingPreviewRecord(){
                this.PrintingRecord(this.codeList,0);
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getShopInventoryList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getShopInventoryList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索取机记录
            onSubmit() {
                  if(this.valueTime1 != null && this.valueTime1.length > 1 ){
                    this.searchForm.attribute1 = new Date(this.valueTime1[0])
                    this.searchForm.attribute2 = new Date(this.valueTime1[1])
                }else{
                    this.searchForm.attribute1 = "";
                    this.searchForm.attribute2 = "";
                }
                this.getShopInventoryList()
                // this.$refs[this.searchForm].validate((valid) => {
                //     if (valid) {

                //     } else {
                //         return false;
                //     }
                // });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    }
    #unEntryManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
        .active-status{
            color:#409EFF;
            cursor:pointer
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }
     .hewidth {
        width: 13% !important;
      }

</style>



// WEBPACK FOOTER //
// unEntryManage.vue?6bce4526